import { useState, useRef, useEffect } from "react";
import { useMobile } from "shared/lib/hooks";
import { Button } from "../button";
import PrevBtn from "shared/assets/images/PrevBtn.svg";
import NextBtn from "shared/assets/images/NextBtn.svg";
import styles from "./Carousel.module.scss";

export const Carousel = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(4);
  const [isTransitioning, setIsTransitioning] = useState(true);

  const isMobile = useMobile("480px");
  const isTablet = useMobile("950px");

  useEffect(() => {
    if (isMobile) {
      setSlidesToShow(1);
    } else if (isTablet) {
      setSlidesToShow(2);
    } else {
      setSlidesToShow(4);
    }
  }, [isMobile, isTablet]);

  const extendedSlides = [...slides, ...slides, ...slides];
  const originalLength = slides.length;

  const startIndex = originalLength;
  const maxIndex = originalLength * 3 - slidesToShow;
  const minIndex = originalLength;

  const nextSlide = () => {
    if (!isTransitioning) return;

    setCurrentIndex((prev) => {
      const next = prev + 1;

      if (next >= maxIndex) {
        setTimeout(() => {
          setIsTransitioning(false);
          setCurrentIndex(startIndex);
          setTimeout(() => setIsTransitioning(true), 50);
        }, 300);
        return next;
      }

      return next;
    });
  };

  const prevSlide = () => {
    if (!isTransitioning) return;

    setCurrentIndex((prev) => {
      const next = prev - 1;

      if (next < minIndex) {
        setTimeout(() => {
          setIsTransitioning(false);
          setCurrentIndex(maxIndex - slidesToShow);
          setTimeout(() => setIsTransitioning(true), 50);
        }, 300);
        return next;
      }

      return next;
    });
  };

  return (
    <div className={styles.carouselContainer}>
      <div className={styles.newsWrapper__buttons}>
        <Button
          variant="ghost"
          size="small"
          onClick={prevSlide}
          leftIcon={
            <img src={PrevBtn} alt="perev" height={isMobile ? 34 : 48} />
          }
        />
      </div>
      <div className={styles.carouselViewport}>
        <div
          className={styles.carouselViewport__track}
          style={{
            transform: `translateX(-${currentIndex * (100 / slidesToShow)}%)`,
            transition: isTransitioning ? "transform 0.3s ease-in-out" : "none",
          }}
        >
          {extendedSlides.map((slide, index) => (
            <div
              key={index}
              className={styles.slide}
              style={{
                width: `${100 / slidesToShow}%`,
              }}
            >
              <div className={styles.slide__content}>
                <div className={styles.slide__imageWrapper}>
                  <img
                    src={slide.image}
                    alt={slide.text}
                    className={styles.slide__image}
                  />
                </div>
                <p className={styles.slide__text}>{slide.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.newsWrapper__buttons}>
        <Button
          variant="ghost"
          size="small"
          onClick={nextSlide}
          leftIcon={
            <img src={NextBtn} alt="next" height={isMobile ? 34 : 48} />
          }
        />
      </div>
    </div>
  );
};
